__webpack_require__.p = "/life-struggler/";